import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './disability.reducer';

export const DisabilityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const disabilityEntity = useAppSelector(state => state.disability.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="disabilityDetailsHeading">
          <Translate contentKey="apiLocationApp.disability.detail.title">Disability</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{disabilityEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.disability.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{disabilityEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.disability.date">Date</Translate>
            </span>
          </dt>
          <dd>{disabilityEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.disability.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{disabilityEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.disability.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{disabilityEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.disability.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{disabilityEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="disabledUnderDisabilityAct">
              <Translate contentKey="apiLocationApp.disability.disabledUnderDisabilityAct">Disabled Under Disability Act</Translate>
            </span>
          </dt>
          <dd>{disabilityEntity.disabledUnderDisabilityAct}</dd>
          <dt>
            <span id="notDisabledUnderDisabilityAct">
              <Translate contentKey="apiLocationApp.disability.notDisabledUnderDisabilityAct">Not Disabled Under Disability Act</Translate>
            </span>
          </dt>
          <dd>{disabilityEntity.notDisabledUnderDisabilityAct}</dd>
        </dl>
        <Button tag={Link} to="/disability" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/disability/${disabilityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DisabilityDetail;
